export const INVENTORY_CATEGORY_OPTIONS = [
  "Velas",
  "Incensos",
  "Cristais",
  "Óleos",
  "Elementos",
  "Pombas Gira",
  "Banhos",
  "Defumadores",
  "Essências",
  "Outros",
] as const;
